import { render } from "./ArrowBackSvg.vue?vue&type=template&id=f6797638"
const script = {}

import exportComponent from "/home/runner/work/binity-order/binity-order/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__